import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import axiosInstance from "../../Axios";
import useAuth from "../../contexts/UserContext.tsx";
import { toast } from "sonner";

function CustomToolbar() {
  return (
    <GridToolbarContainer
      sx={{ padding: 2, display: "flex", justifyContent: "space-between" }}
    >
      <GridToolbarQuickFilter />
      <div className="flex">
        <GridToolbarExport printOptions={{ disableToolbarButton: true }} />
      </div>
    </GridToolbarContainer>
  );
}

const SyncStatus = () => {
  const [loading, setLoading] = useState(false);

  const [serverSyncedData, setServerSyncedData] = useState();
  const { user, logout } = useAuth();

  // data refractoring - school types
  const school_types = user.view_access_list.school_types
    .split(",")
    .map((item) => `'${item}'`)
    .join(",");
  const school_types_array = school_types
    .replaceAll("'", "")
    .split(",")
    .map((school_type) => ({
      label: school_type,
      value: school_type,
    }));

  const district_names = user.view_access_list.district
    .split(",")
    .map((word) => `'${word}'`)
    .join(",");
  const district_names_array = district_names
    .replaceAll("'", "")
    .split(",")
    .map((district_name) => ({
      label: district_name,
      value: district_name,
    }));

  const [schoolTypeOptionsSelected, setSchoolTypeOptionsSelected] = useState(
    school_types_array.map((item) => item.value)
  );
  const [districtOptionsSelected, setDistrictOptionsSelected] = useState(
    district_names_array.map((item) => item.value)
  );

  const handleSelectAllSchoolChange = () => {
    if (schoolTypeOptionsSelected.length === school_types_array.length) {
      setSchoolTypeOptionsSelected([]);
    } else {
      setSchoolTypeOptionsSelected(
        school_types_array.map((item) => item.value)
      );
    }
  };

  const handleSelectAllDistrictChange = () => {
    if (districtOptionsSelected.length === district_names_array.length) {
      setDistrictOptionsSelected([]);
    } else {
      setDistrictOptionsSelected(
        district_names_array.map((item) => item.value)
      );
    }
  };

  const clickSubmitHandler = async () => {
    const school_str = schoolTypeOptionsSelected
      .map((item) => `'${item}'`)
      .join(",");
    const district_str = districtOptionsSelected
      .map((item) => `'${item}'`)
      .join(",");

    try {
      setLoading(true);
      const res = await axiosInstance.post("serversyncedstatus", {
        user_id: user.user_id,
        auth_token: user.auth_token,
        school_types: school_str,
        district_names: district_str,
      });
      if (res.data.data.message === "Invalid User") {
        toast.error("Invalid User");
        logout();
        return;
      }
      setServerSyncedData(res.data.data.server_synced_status);
    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  const getServerSyncedData = async () => {
    try {
      setLoading(true);
      const res = await axiosInstance.post("serversyncedstatus", {
        user_id: user.user_id,
        auth_token: user.auth_token,
        school_types: school_types,
        district_names: district_names,
      });
      setServerSyncedData(res.data.data.server_synced_status);
    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      field: "center_id",
      headerName: "Center ID",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "center_name",
      headerName: "Center Name",
      flex: 3,
      minWidth: 400,
    },
    {
      field: "last_video_view_date",
      headerName: "Last sync date",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "school_name",
      headerName: "School Name",
      minWidth: 400,
      flex: 3,
    },
    {
      field: "district",
      headerName: "District",
      minWidth: 100,
      flex: 1,
    },
  ];

  useEffect(() => {
    getServerSyncedData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div className="flex gap-2 mt-2">
        <FormControl fullWidth>
          <InputLabel id="checkbox-dropdown-label">School Types</InputLabel>
          <Select
            labelId="checkbox-dropdown-label"
            id="checkbox-dropdown"
            multiple
            label="School Types"
            value={schoolTypeOptionsSelected}
            onChange={() => {}}
            renderValue={(selected) => [...selected].join(", ")}
          >
            <MenuItem key="select-all" onClick={handleSelectAllSchoolChange}>
              <FormControlLabel
                control={
                  <Checkbox
                    indeterminate={
                      schoolTypeOptionsSelected.length > 0 &&
                      schoolTypeOptionsSelected.length <
                        school_types_array.length
                    }
                    checked={
                      schoolTypeOptionsSelected.length ===
                      school_types_array.length
                    }
                  />
                }
                label="Select All"
              />
            </MenuItem>
            {school_types_array.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={schoolTypeOptionsSelected.includes(option.value)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSchoolTypeOptionsSelected([
                            ...schoolTypeOptionsSelected,
                            option.value,
                          ]);
                        } else {
                          setSchoolTypeOptionsSelected(
                            schoolTypeOptionsSelected.filter(
                              (type) => type !== option.value
                            )
                          );
                        }
                      }}
                    />
                  }
                  label={option.label}
                />
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth>
          <InputLabel id="checkbox-dropdown-label">District</InputLabel>
          <Select
            labelId="checkbox-dropdown-label"
            id="checkbox-dropdown"
            multiple
            label="Districts"
            value={districtOptionsSelected}
            onChange={() => {}}
            renderValue={(selected) => [...selected].join(", ")}
          >
            <MenuItem key="select-all" onClick={handleSelectAllDistrictChange}>
              <FormControlLabel
                control={
                  <Checkbox
                    indeterminate={
                      districtOptionsSelected.length > 0 &&
                      districtOptionsSelected.length <
                        district_names_array.length
                    }
                    checked={
                      districtOptionsSelected.length ===
                      district_names_array.length
                    }
                  />
                }
                label="Select All"
              />
            </MenuItem>
            {district_names_array.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={districtOptionsSelected.includes(option.value)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setDistrictOptionsSelected([
                            ...districtOptionsSelected,
                            option.value,
                          ]);
                        } else {
                          setDistrictOptionsSelected(
                            districtOptionsSelected.filter(
                              (type) => type !== option.value
                            )
                          );
                        }
                      }}
                    />
                  }
                  label={option.label}
                />
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <button
          onClick={clickSubmitHandler}
          className="bg-blue-500 rounded-md hover:bg-blue-700 w-[250px] text-white"
        >
          Submit
        </button>
      </div>
      {loading ? (
        <div className="flex justify-center items-center h-[500px]">
          <Typography variant="h5" className="text-gray-400">
            Loading...
          </Typography>
        </div>
      ) : (
        serverSyncedData && (
          <DataGrid
            columns={columns}
            rows={serverSyncedData}
            rowHeight={50}
            sx={{ marginTop: "1.0em" }}
            autoHeight={true}
            getRowId={(row) => row.center_id}
            components={{
              Toolbar: CustomToolbar,
            }}
            componentsProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
              },
            }}
          />
        )
      )}
    </div>
  );
};

export default SyncStatus;
